<script setup>
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
</script>

<template>
  <div id="mc-app-root">
    <RouterView />
    <Toast position="top-right" />

    <!-- Full-screen overlay during cross-site redirects (login SSO + logout) -->
    <transition name="fade">
      <div v-if="auth.redirecting" class="redirect-overlay">
        <div class="redirect-card">
          <ProgressSpinner style="width: 48px; height: 48px" stroke-width="3" />
          <p class="redirect-text">{{ auth.redirectMessage || 'Redirecting...' }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
#mc-app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.redirect-overlay {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #f7f8fb 0%, #ede9fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.redirect-card {
  background: #fff;
  padding: 2.5rem 3rem;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(67, 56, 202, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.redirect-text {
  color: var(--mc-text);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
